import { Box, type BoxProps } from "@mui/material";

export function Flex(props: BoxProps) {
	return <Box display="flex" {...props} />;
}
